<template>
  <form @submit.prevent="submit">
    <fg-input label="Name"
      type="text"
      v-model="warehouse.name"
      :error="valErrors['name'] ? valErrors['name'][0] : null"
    />
    <fg-input label="Kurzbezeichnung"
      type="text"
      v-model="warehouse.short_name"
      :error="valErrors['short_name'] ? valErrors['short_name'][0] : null"
    />
      <label>Standort</label>
    <div class="form-group has-label">
      <multiselect v-model="warehouse.location"
      @select="handleSelectLocation"
        :options="locations"
        label="name"
        track-by="id"
      />
    </div>
    <fg-input label="Straße"
      type="text"
      v-model="warehouse.street"
      :error="valErrors['street'] ? valErrors['street'][0] : null"
    />
    <div class="row">
      <div class="col-sm-3">
        <fg-input label="PLZ"
          type="text"
          v-model="warehouse.zip"
          :error="valErrors['zip'] ? valErrors['zip'][0] : null"
        />
      </div>
      <div class="col-sm-9">
        <fg-input label="Ort"
          type="text"
          v-model="warehouse.place"
          :error="valErrors['place'] ? valErrors['place'][0] : null"
        />
      </div>
    </div>
    <fg-input label="Benachrichtungen senden an"
      type="email"
      v-model="warehouse.notification_email"
      :error="valErrors['notification_email'] ? valErrors['notification_email'][0] : null"
    />
    <div>
      <fg-input label="Bestell E-Mail Zusatztext Lager"
        icon="fa-question-circle" icon-tooltip="Dieser Text wird automatisch bei Bestellungen die dieses Lager betreffen in die E-Mail eingefügt"
      >
        <textarea class="form-control" v-model="warehouse.order_email_text" rows="7"></textarea>
      </fg-input>
    </div>
    <button type="submit" class="btn btn-fill btn-info">{{ submitText }}</button>
  </form>
</template>

<script>
export default {
  props: ['valErrors', 'initWarehouse', 'submitText'],
  data () {
    return {
      warehouse: this.initWarehouse,
      locations: [],
      warehouseDefaultText: '',
      settings: {},
    }
  },
  methods: {
    handleSelectLocation(location) {
      if(location.warehouse_default_text) {
        this.warehouseDefaultText = location.warehouse_default_text
      } else {
        this.warehouseDefaultText = this.settings.warehouse_default_text
      }
      this.warehouse.order_email_text = this.warehouseDefaultText
    },
    submit () {
      this.warehouse.location_id = this.warehouse.location ? this.warehouse.location.id : null
      this.$emit('submit', this.warehouse)
    }
  },
  created () {
    this.$http.get('locations').then(({ data }) => { this.locations = data })
    this.$http.get('/settings').then(({ data }) => { this.settings = data })
  }
}
</script>

<style>
</style>
